import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Observable, Subject } from 'rxjs';
import { AuthService } from 'app/services/auth.service';
import { PermissionRoute } from 'app/interfaces/permission';
import { PermissionsService } from 'app/services/permissions.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private Authentication: AuthService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean> | boolean {
    if (this.Authentication.userIsAuthenticated()) {
      return true;
    } else {
      if (!window.location.href.match(/\/pages\/login/)) { localStorage.setItem('urlReference', window.location.href.split('#')[1]) }
      this.router.navigate(['/pages/login'])
    }
  }

}

@Injectable({
  providedIn: 'root'
})
export class GuardAdministratorRoutes implements CanActivate {
  constructor() { }

  canActivate(): Observable<boolean> | boolean {
    return !environment.production;
  }
}
@Injectable({
  providedIn: 'root'
})
export class PermissionRouteGuard implements CanActivate {
  state$ = new BehaviorSubject<any>(null);

  constructor(
    private permissionService: PermissionsService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.handleActive(route)
  }

  handleActive(route: ActivatedRouteSnapshot) {
    const necessaryPermission: PermissionRoute = route.data.roles;
    if (necessaryPermission.route === 'dashboard') {
      this.state$.next(null)
      return true
    } else {
      if (this.state$.getValue() && window.location.hash !== '#/pages/login') {
        return (
          this.state$.getValue()[necessaryPermission.target][necessaryPermission.route].includes(necessaryPermission.permission)
        )
      } else if (necessaryPermission.route === 'politica-representantes') {
        return this.permissionService.getPermissionsToPromise()
          .then((permissions) => {
            this.state$.next(permissions)
            return (permissions[necessaryPermission.target] === necessaryPermission.permission)
          }
          ).catch(err => {
            return false;
          })
      } else {
        return this.permissionService.getPermissionsToPromise()
          .then((permissions) => {
            this.state$.next(permissions)
            return (permissions[necessaryPermission.target][necessaryPermission.route].includes(necessaryPermission.permission))
          }
          ).catch(err => {
            return false;
          })
      }
    }
  }
}
